import React, { useState } from "react";
import { SmartFilterPill } from "./SmartFilterPill";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui";
import { SmartFilterPopup } from "./SmartFilterPopup";
import { FilterState } from "../FilterSidebar/FilterState";
import { SmartFilter as SmartFilterType } from "./types";
import { cn } from "@/lib/utils";
import {
  filterStateVar,
  initialFilterStateVar,
} from "@/reactiveVars/organization";

const POPUP_CLASSES: Record<string, string> = {
  commitmentRisk: "w-76",
  meltRisk: "w-79",
};

export const SmartFilter = ({
  smartFilter,
  filterState,
}: {
  smartFilter: SmartFilterType;
  filterState: FilterState | null;
}) => {
  const [popupOpen, setPopupOpen] = useState<boolean>(false);

  const selectedOption =
    (filterState &&
      smartFilter.options.find((opt) => opt.filterState.isEqual(filterState))
        ?.value) ||
    null;

  const handleApply = (value: string | null) => {
    if (value === null) {
      const clearedFilter = new FilterState({});
      filterStateVar(clearedFilter);
      initialFilterStateVar(clearedFilter);
      return;
    }
    // get selected option
    const selectedOpt = smartFilter.options.find((opt) => opt.value === value);
    if (selectedOpt) {
      filterStateVar(selectedOpt.filterState);
      initialFilterStateVar(selectedOpt.filterState);
    }
    setPopupOpen(false);
  };

  if (smartFilter.options.length === 1) {
    const opt = smartFilter.options[0];
    return (
      <SmartFilterPill
        smartFilter={smartFilter}
        selected={!!selectedOption}
        onClick={() => {
          handleApply(opt.value !== selectedOption ? opt.value : null);
        }}
      />
    );
  }

  return (
    <Popover open={popupOpen} onOpenChange={setPopupOpen}>
      <PopoverTrigger asChild={true}>
        <div>
          <SmartFilterPill
            smartFilter={smartFilter}
            selected={!!selectedOption}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent className={cn(POPUP_CLASSES[smartFilter.id])}>
        <SmartFilterPopup
          smartFilter={smartFilter}
          initialValue={selectedOption}
          onApply={handleApply}
        />
      </PopoverContent>
    </Popover>
  );
};
